import { Component, OnInit } from "@angular/core";
import { ScrollingService } from "../services/scrolling.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-impressum",
  templateUrl: "./impressum.component.html",
  styleUrls: ["./impressum.component.scss"],
})
export class ImpressumComponent implements OnInit {
  constructor(private scrolling: ScrollingService, private router: Router) {
    scrolling.reset();

    window.scrollTo(0, 0);
  }

  ngOnInit() {}
}
